import { compactObject } from '@ota-frontend/core/utils'

export default {
  methods: {
    __gtmDataLayerOnNewTourList(condition) {
      // ツアー一覧更新時に送信されるものとして定義した GTM のカスタムイベントの dataLayer
      // パラメータの内容は既存仕様を元にしている
      // https://github.com/tabikobo/www.tabikobo.com_tour/blob/d063f48cb0ab53a6c09e4231f85273d6180042b2/app/View/Elements/gtm_tags_head.ctp
      // https://github.com/tabikobo/www.tabikobo.com_tour/blob/424cc0b1311b7ce26988910eef512b148af00fad/app/Plugin/Tour/Controller/SearchToursController.php#L2008
      //
      // this.tours を store 管理し、store への action をフックするミドルウェアとして定義した方が良いかもしれない

      // ロケーションの英語名は
      // city_id['', 2, 3, 4] > country_id > region_id の優先順で検索したエリア情報から設定
      // 既存仕様：
      // https://github.com/tabikobo/www.tabikobo.com_tour/blob/424cc0b1311b7ce26988910eef512b148af00fad/app/Plugin/Tour/Controller/SearchToursController.php#L2069
      const areaForEnName = (destinations => {
        if (destinations[0].cityId) return destinations[0]
        if (destinations[1].cityId) return destinations[1]
        if (destinations[2].cityId) return destinations[2]
        if (destinations[3].cityId) return destinations[3]
        if (destinations[0].countryId) return destinations[0]
        if (destinations[0].regionId) return destinations[0]
        return null
      })(condition.destinations)

      // 日付条件 は y-m、d、duration_from から設定
      const from = condition.departureDateObject
      const to = from && condition.durationFrom
        ? new Date(from.getFullYear(), from.getMonth(), from.getDate() + condition.durationFrom)
        : undefined

      // xxx_name_en のデフォルト値 Japan, hokkaido, sapporo は既存仕様による：
      // https://github.com/tabikobo/www.tabikobo.com_tour/blob/424cc0b1311b7ce26988910eef512b148af00fad/app/Plugin/Tour/Controller/SearchToursController.php#L2175
      return compactObject({
        // ロケーションの日本語名はクエリパラメータの第一目的地から設定
        region_name: condition.destinations[0].regionName,
        country_name: condition.destinations[0].countryName,
        city_name: condition.destinations[0].cityName,

        // ロケーションの英語名は上記仕様で設定
        region_name_en: areaForEnName && areaForEnName.regionNameEn || 'Japan',
        country_name_en: areaForEnName && areaForEnName.countryNameEn || 'hokkaido',
        city_name_en: areaForEnName && areaForEnName.cityNameEn || 'sapporo',

        // Date.toISOString は UTC でしか出力できないため使えない点に注意
        preferred1_date: from && `${from.getFullYear()}-${String(from.getMonth() + 1).padStart(2, '0')}-${String(from.getDate()).padStart(2, '0')}`,
        preferred1_end_date: to && `${to.getFullYear()}-${String(to.getMonth() + 1).padStart(2, '0')}-${String(to.getDate()).padStart(2, '0')}`,
      })
    }
  }
}
